import { call, put, takeLatest } from "redux-saga/effects";
import { eSubSystemActionTypeIds } from "../../action-types/sub-sytem/ISubSytemActionTypes";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { subSystemApi } from "../../../api/sub-sytem/subSystemApi";
import { actions } from "../../actions";

export function* subSystemSaga(): any {
    yield takeLatest(eSubSystemActionTypeIds.LOAD_START, loadWorker)
}
function* loadWorker(): any {
    const res: IBaseRespone = yield call(subSystemApi.getAll)
    if (res.is_success) {
        yield put(actions.subSystem.loadSuccess(res.data))
    } else {
        yield put(actions.subSystem.loadError(res.message))
    }
}